var _path, _path2, _path3, _path4, _path5, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTechnicalSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5163 13.0987L24.3667 10.1072L22.1231 9.88289L21.3753 7.56454L22.5718 5.84447L19.5056 2.77826L17.4864 3.97483L15.6168 3.22697L15.1681 1.05811L10.6061 1.13284L10.0826 3.00249L8.06342 3.9747L6.49292 2.8528L3.27714 5.91888L3.95021 7.19012L2.978 9.88239L1.25781 10.331V14.8182L3.08732 15.104L3.95951 16.8346L3.09403 18.8533L6.23955 22.2811L7.85264 20.9906L10.4739 22.2408L10.5949 24.1765L13.0145 24.0555",
    stroke: "#0C1C33",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6169 27.0752L12.8879 31.0581L18.625 29.6097C25.1636 32.0237 30.4257 29.9245 32.0761 28.5163C37.0363 24.754 35.3646 19.6525 34.1072 18.1438C31.6709 14.7644 26.9031 13.8391 24.5192 13.7989C18.8608 13.5575 15.5594 16.3597 14.3812 18.2645C12.1178 22.0302 13.5953 25.7073 14.6169 27.0752Z",
    stroke: "#0C1C33",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9631 23.5276C18.7707 23.5276 19.4254 22.8729 19.4254 22.0653C19.4254 21.2576 18.7707 20.6029 17.9631 20.6029C17.1554 20.6029 16.5007 21.2576 16.5007 22.0653C16.5007 22.8729 17.1554 23.5276 17.9631 23.5276Z",
    fill: "#0C1C33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1569 23.5276C24.9646 23.5276 25.6193 22.8729 25.6193 22.0653C25.6193 21.2576 24.9646 20.6029 24.1569 20.6029C23.3493 20.6029 22.6946 21.2576 22.6946 22.0653C22.6946 22.8729 23.3493 23.5276 24.1569 23.5276Z",
    fill: "#0C1C33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3505 23.5276C31.1582 23.5276 31.8129 22.8729 31.8129 22.0653C31.8129 21.2576 31.1582 20.6029 30.3505 20.6029C29.5429 20.6029 28.8882 21.2576 28.8882 22.0653C28.8882 22.8729 29.5429 23.5276 30.3505 23.5276Z",
    fill: "#0C1C33"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8881,
    cy: 12.6168,
    r: 4.37094,
    stroke: "#0C1C33",
    strokeWidth: 1.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTechnicalSupport);
export default __webpack_public_path__ + "static/media/ic-technical-support.35900836d69c12a00f6b1c0b2d031def.svg";
export { ForwardRef as ReactComponent };